import { useEffect, useState } from "react";
import { api } from "@/api";
import { Globe } from "lucide-react";

export function EnvSwitcher() {
  const [envs, setEnvs] = useState([]);
  const [active, setActive] = useState(localStorage.getItem("activeEnvId") || "master");
  useEffect(() => { api.get("/environments").then(({ data }) => setEnvs(data || [])).catch(() => {}); }, []);
  if (envs.length <= 1) return null;
  const change = (id) => {
    if (id === "master") localStorage.removeItem("activeEnvId");
    else localStorage.setItem("activeEnvId", id);
    setActive(id);
    window.location.reload();
  };
  return (
    <div data-testid="env-switcher" className="hidden items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-2 py-1 text-xs font-semibold text-slate-700 sm:inline-flex">
      <Globe style={{ width: 14, height: 14 }} className="text-blue-600" />
      <select data-testid="env-switcher-select" value={active} onChange={(e) => change(e.target.value)} className="bg-transparent outline-none">
        {envs.map((e) => <option key={e.id} value={e.id}>{e.name}{e.is_master ? "" : ` · ${e.code}`}</option>)}
      </select>
    </div>
  );
}
